import React, { useEffect, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import CustomSelect from "components/fragments/CustomSelect";
import CustomInput from "components/fragments/CustomInput";
import CustomBtn from "components/fragments/CustomBtn";
import OTPInput from "react-otp-input";
import { useDispatch, useSelector } from "react-redux";
import { billHandler, authHandler } from "../../redux/handlers";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import { masterHandler } from "../../redux/handlers";

const selectStyles = {
  ".MuiInputBase-input": {
    display: "flex",
    alignItems: "center",
    padding: "8px 14px",
    color: "#061126",
  },
  fieldset: {
    border: 0,
    background: "rgb(255, 255, 255)",
    borderRadius: "8px",
    filter: "drop-shadow(rgba(0, 0, 0, 0.14) 0px 2px 4px)",
    color: "#061126",
  },
  ".MuiSvgIcon-root": {
    zIndex: 9,
  },
  ".MuiSelect-select": {
    zIndex: 10,
    height: "32.4px",
  },
};

const pinCount = 4;

export default function ModalReturnProduct({
  modalOpenObj,
  billdata,
  returnProduct,
  setReturnProduct,
  businessSlug,
  onReturnSuccess,
}) {
  const [step, setStep] = useState(1);
  const [product, setProduct] = useState([]);
  const [pin, setPin] = useState("");
  const [isError, setIsError] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (modalOpenObj.modalOpen) {
      if (returnProduct.product && returnProduct.product.length > 0) {
        setProduct(returnProduct.product);
      } else {
        setProduct([]);
      }
    } else {
      setStep(1);
      setProduct([]);
      setPin("");
      setIsError(undefined);
      setIsSubmitting(false);
    }
  }, [modalOpenObj.modalOpen, returnProduct.product]);

  useEffect(() => {
    setIsError(undefined);
  }, [pin]);

  const handleCloseModal = () => {
    if (!isSubmitting) {
      modalOpenObj.setModalOpen(false);
      setStep(1);
      setProduct([]);
      setPin("");
      setIsError(undefined);
      setIsSubmitting(false);

      setReturnProduct((prev) => ({
        ...prev,
        product: [],
        reason: "",
        note: "",
      }));
    }
  };

  const handlePinSubmit = async () => {
    try {
      if (pin.length !== 4) {
        setIsError("true");
        return;
      }

      setIsSubmitting(true);

      const branchData = {
        pin: pin,
      };

      const response = await dispatch(
        authHandler.authenticateEmployee(businessSlug, branchData)
      );

      if (response) {
        setIsError(undefined);
        setPin("");
        setIsSubmitting(false);
        setStep(2);
      } else {
        setPin("");
        setIsError("true");
        setIsSubmitting(false);
      }
    } catch (error) {
      setPin("");
      setIsError("true");
      setIsSubmitting(false);
      console.error(error);
    }
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={modalOpenObj.modalOpen}
        onClose={handleCloseModal}
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={modalOpenObj.modalOpen}>
          <div
            className={`bg-white focus-visible-none px-4 py-3 absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] rounded-[min(1.46vw,15px)] text-16 text-[var(--color-black-2)] ${
              step === 1 || step === 4
                ? "w-[450px]"
                : "w-[700px] max-w-[min(77.11vw,780px)]"
            }`}
          >
            {step === 1 ? (
              <PinVerification
                pin={pin}
                setPin={setPin}
                isError={isError}
                isSubmitting={isSubmitting}
                onSubmit={handlePinSubmit}
                onCancel={handleCloseModal}
              />
            ) : step === 2 ? (
              <SelectReturnProduct
                billdata={billdata}
                product={product}
                setProduct={setProduct}
                setStep={setStep}
                returnProduct={returnProduct}
                setReturnProduct={setReturnProduct}
                modalOpenObj={modalOpenObj}
              />
            ) : step === 3 ? (
              <ConfirmReturnProduct
                billdata={billdata}
                product={product}
                setProduct={setProduct}
                setStep={setStep}
                returnProduct={returnProduct}
                setReturnProduct={setReturnProduct}
                modalOpenObj={modalOpenObj}
                businessSlug={businessSlug}
                onReturnSuccess={onReturnSuccess}
              />
            ) : step === 4 ? (
              <StockConfirmation
                returnProduct={returnProduct}
                setReturnProduct={setReturnProduct}
                setStep={setStep}
                modalOpenObj={modalOpenObj}
                billdata={billdata}
                businessSlug={businessSlug}
                onReturnSuccess={onReturnSuccess}
              />
            ) : null}
          </div>
        </Fade>
      </Modal>
    </div>
  );
}

const PinVerification = ({
  pin,
  setPin,
  isError,
  isSubmitting,
  onSubmit,
  onCancel,
}) => {
  return (
    <div className="text-center">
      <div className="text-[20px] font-semibold mb-4">คืนสินค้า</div>
      <div className="leading-[2.2] mb-4">กรุณาใส่รหัสยืนยัน</div>

      <div className={"flex justify-center mt-[min(1.46vw,15px)] mb-6"}>
        <OTPInput
          value={pin}
          onChange={setPin}
          numInputs={pinCount}
          inputStyle={null}
          renderSeparator={<div className="w-[min(1.95vw,20px)]"></div>}
          renderInput={(props, index) => {
            const { style, ...rest } = props;
            return (
              <CustomInput
                className="w-[min(5.96vw,61px)] aspect-square"
                inputprops={{
                  ...rest,
                  className:
                    "rounded-[min(0.78vw,8px)] border-[min(0.29vw,3px)] border-[#b6bbc6] font-[400] text-24 text-center no-spinner",
                  type: "number",
                  error: isError,
                }}
              />
            );
          }}
        />
      </div>

      <div className="flex justify-center gap-[min(2.01vw,20.63px)]">
        <CustomBtn
          onClick={onCancel}
          className={`leading-[0.8] w-fit min-w-[min(10.25vw,105px)] text-18 text-[#6D788D] font-[600] min-h-[min(3.91vw,40px)] rounded-[min(0.78vw,8px)] btn-second-2-active`}
          btntxt={"ยกเลิก"}
          disabled={isSubmitting}
        />
        <CustomBtn
          onClick={onSubmit}
          className={`leading-[0.8] w-fit min-w-[min(10.25vw,105px)] text-18 text-white font-[600] min-h-[min(3.91vw,40px)] rounded-[min(0.78vw,8px)] btn-main-active`}
          btntxt={"ยืนยัน"}
          disabled={isSubmitting}
        />
      </div>
    </div>
  );
};

const SelectReturnProduct = ({
  billdata,
  product,
  setProduct,
  setStep,
  returnProduct,
  setReturnProduct,
  modalOpenObj,
}) => {
  const calculatePricePerUnit = (item) => {
    const totalPrice = parseFloat(item.productSumPrice);
    const quantity = parseInt(item.productQty);
    if (quantity > 0) {
      return totalPrice / quantity;
    }
    return 0;
  };

  const handleCheckboxChange = (e, item) => {
    if (e.target.checked) {
      const existingProductIndex = product.findIndex(
        (p) => p.id === item.billItemId
      );

      if (existingProductIndex === -1) {
        const pricePerUnit = calculatePricePerUnit(item);
        setProduct((prev) => [
          ...prev,
          {
            id: item.billItemId,
            productPrice: item.productPrice,
            productPricePerPiece: pricePerUnit,
            productName: item.productName,
            productImage: item.productImage,
            optionnote: item.optionnote,
            optionproduct: item.optionproduct,
            optionstandard: item.optionstandard,
            product_return_qty: 0,
          },
        ]);
      }
    } else {
      setProduct(product.filter((dx) => dx.id !== item.billItemId));
    }
  };

  const handleDecreaseQuantity = (itemId) => {
    setProduct((prev) =>
      prev.map((el) =>
        el.id === itemId
          ? {
              ...el,
              product_return_qty:
                el.product_return_qty > 1 ? el.product_return_qty - 1 : 0,
            }
          : el
      )
    );
  };

  const handleIncreaseQuantity = (itemId, maxQty) => {
    setProduct((prev) =>
      prev.map((el) =>
        el.id === itemId
          ? {
              ...el,
              product_return_qty:
                el.product_return_qty < maxQty
                  ? el.product_return_qty + 1
                  : maxQty,
            }
          : el
      )
    );
  };

  return (
    <>
      <div className="text-[20px] font-semibold mb-4">คืนสินค้า</div>
      <ul className="p-0 m-0 w-100">
        <li className="px-2">
          <div className="row gx-2 align-items-start mb-3">
            <div className="col-6 fs-14">รายการ</div>
            <div className="col fs-14 text-center">จำนวน</div>
            <div className="col fs-14 text-end">ราคา</div>
            <div className="col-3 fs-14 text-center">จำนวนที่คืน</div>
          </div>
        </li>
        {billdata?.product?.map((item, index) => {
          const isSelected = product.some((p) => p.id === item.billItemId);
          const selectedProduct = product.find((p) => p.id === item.billItemId);

          return (
            <li className="px-2" key={item.id}>
              <div className="row gx-2 align-items-start mb-3">
                <div className="col-1 mt-2">
                  <div className="">
                    <input
                      className="form-check-input form-option"
                      type="checkbox"
                      checked={isSelected}
                      onChange={(e) => handleCheckboxChange(e, item)}
                    />
                  </div>
                </div>
                <div className="col-5 mb-2">
                  <div className="d-flex align-items-center">
                    <img
                      src={item.productImage}
                      className="foodimg w-[52px] h-[39px] object-cover"
                      alt={item.productName}
                    />
                    <div className="fs-12 ms-2">{item.productName}</div>
                  </div>

                  <div className="d-flex flex-wrap bx-Foption">
                    {item.optionstandard?.map((option) => (
                      <div className="Foption mt-2" key={option.listID}>
                        {option.itemName}
                      </div>
                    ))}
                    {item.optionproduct?.map((option) => (
                      <div className="Foption mt-2" key={option.listID}>
                        {option.itemName}
                      </div>
                    ))}
                  </div>

                  {((item.optionnote && item.optionnote.length > 0) ||
                    item.note) && (
                    <div className="fNote">
                      {item.optionnote?.map((note, index) => (
                        <span key={note.listID}>
                          {note.itemName}
                          {index !== item.optionnote.length - 1 ? "," : ""}{" "}
                        </span>
                      ))}
                      {item.note}
                    </div>
                  )}
                </div>
                <div className="col fs-14 text-center foodQtyli mt-2">
                  {item.productQty}
                </div>
                <div className="col fs-14 text-end mt-2">
                  <span className="foodPriceli">
                    {Number(item.productSumPrice).toFixed(2)}
                  </span>
                  .-
                </div>
                <div className="col-3 fs-14 text-center mt-1">
                  <div className="d-flex align-items-center w-100 justify-center">
                    <button
                      type="button"
                      className="btn btn-minus !bg-transparent"
                      disabled={!isSelected}
                      onClick={() => handleDecreaseQuantity(item.billItemId)}
                    ></button>

                    <input
                      type="number"
                      name="foodQty"
                      className="form-control mx-0 text-center lh-1 foodQty w-[43px]"
                      value={
                        isSelected ? selectedProduct.product_return_qty : 0
                      }
                      readOnly
                    />

                    <button
                      type="button"
                      className="btn btn-plus !bg-transparent"
                      disabled={!isSelected}
                      onClick={() =>
                        handleIncreaseQuantity(item.billItemId, item.productQty)
                      }
                    ></button>
                  </div>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
      <div className="text-end py-2">
        <button
          type="button"
          className="btn btn-st-2 px-5 py-3 lh-1 me-3 bg-[#E6E6E6]"
          onClick={() => modalOpenObj.setModalOpen(false)}
        >
          ยกเลิก
        </button>
        <button
          className="btn btn-login px-5 py-3 lh-1"
          onClick={() => setStep(3)}
          disabled={!product.some((item) => item.product_return_qty > 0)}
        >
          ถัดไป
        </button>
      </div>
    </>
  );
};

const StockConfirmation = ({
  returnProduct,
  setReturnProduct,
  setStep,
  modalOpenObj,
  billdata,
  businessSlug,
  onReturnSuccess,
}) => {
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [refundMethod, setRefundMethod] = useState("");
  const paymentMethods = useSelector((state) => state.master.paymentMethods);

  useEffect(() => {
    dispatch(masterHandler.getPaymentMethods());
  }, [dispatch]);

  const refundOptions =
    paymentMethods?.filter((method) =>
      ["CASH", "CREDIT_CARD", "BANK_TRANSFER"].includes(method.code)
    ) || [];

  useEffect(() => {
    if (refundOptions.length > 0 && !refundMethod) {
      const cashOption = refundOptions.find((method) => method.code === "CASH");
      if (cashOption) {
        setRefundMethod(cashOption.id);
      }
    }
  }, [refundOptions, refundMethod]);

  const totalRefundAmount = returnProduct.product
    ? returnProduct.product.reduce(
        (total, item) => total + parseFloat(item.calculatedPrice || 0),
        0
      )
    : 0;

  const handleFinalSubmit = async () => {
    try {
      setIsSubmitting(true);

      let temp = [];
      returnProduct.product.forEach((item) => {
        temp.push({
          bill_item_id: Number(item.id),
          qty: item.product_return_qty,
        });
      });

      const form = {
        bill_id: billdata.billID,
        bill_cancel_remark_id: returnProduct.reason_id,
        remark: returnProduct.reason,
        refund_payment_method_id: refundMethod,
        items: temp,
      };

      const response = await dispatch(
        billHandler.returnBill(form, businessSlug)
      );
      if (response) {
        if (onReturnSuccess) {
          await onReturnSuccess(response);
        }
        modalOpenObj.setModalOpen(false);
        setStep(1);
        setReturnProduct({
          product: [],
          reason: "",
          note: "",
          stock: 0,
        });
      }
    } catch (error) {
      console.error("Error returning products:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="text-center py-2">
      <div className="text-[24px] font-[700] text-[#FF0000] mb-6">
        สรุปการคืนสินค้า
      </div>

      <div className="mb-6">
        <div className="text-[18px] text-[#061126] mb-4">
          คุณต้องการคืนสต็อกสินค้าใช่หรือไม่{" "}
          <span className="text-red-500">*</span>
        </div>

        <div className="flex justify-center gap-8 mb-6">
          <label className="flex items-center cursor-pointer">
            <input
              type="radio"
              name="stock"
              value="0"
              checked={returnProduct.stock === "0"}
              onChange={(e) => {
                setReturnProduct((prev) => ({
                  ...prev,
                  stock: e.target.value,
                }));
              }}
              className="w-5 h-5 mr-3"
            />
            <span className="text-[16px]">ไม่คืนสต็อกสินค้า</span>
          </label>

          <label className="flex items-center cursor-pointer">
            <input
              type="radio"
              name="stock"
              value="1"
              checked={returnProduct.stock === "1"}
              onChange={(e) => {
                setReturnProduct((prev) => ({
                  ...prev,
                  stock: e.target.value,
                }));
              }}
              className="w-5 h-5 mr-3"
            />
            <span className="text-[16px]">คืนสต็อกสินค้า</span>
          </label>
        </div>
      </div>

      <div className="mb-6">
        <div className="text-[18px] text-[#061126] mb-4">
          ช่องทางการคืนเงิน <span className="text-red-500">*</span>
        </div>

        <FormControl fullWidth>
          <Select
            value={refundMethod}
            onChange={(e) => setRefundMethod(e.target.value)}
            sx={selectStyles}
            displayEmpty
            disabled={true}
          >
            <MenuItem value="" disabled>
              <span style={{ color: "#999" }}>เลือกช่องทางการคืนเงิน</span>
            </MenuItem>
            {refundOptions.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                <ListItemText primary={option.name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      <div className="bg-[#FFC2C2] border border-red-200 rounded-lg p-2 mb-6">
        <div className="text-[18px] text-[#FF0000] font-semibold mb-2">
          มูลค่าที่ต้องคืน
        </div>
        <div className="text-[32px] text-[#FF0000] font-bold">
          {totalRefundAmount.toFixed(2)} ฿
        </div>
      </div>

      <div className="flex justify-center gap-4">
        <button
          onClick={() => setStep(3)}
          className="px-8 py-2 bg-red-500 text-white text-[18px] font-semibold rounded-lg hover:bg-red-600 transition-colors"
          disabled={isSubmitting}
        >
          ยกเลิก
        </button>
        <button
          onClick={handleFinalSubmit}
          className="px-8 py-2 bg-green-500 text-white text-[18px] font-semibold rounded-lg hover:bg-green-600 transition-colors disabled:opacity-50"
          disabled={isSubmitting || !returnProduct.stock}
        >
          {isSubmitting ? "กำลังดำเนินการ..." : "ยืนยัน"}
        </button>
      </div>
    </div>
  );
};

const ConfirmReturnProduct = ({
  billdata,
  product,
  setProduct,
  setStep,
  returnProduct,
  setReturnProduct,
  modalOpenObj,
  businessSlug,
  onReturnSuccess,
}) => {
  const dispatch = useDispatch();
  const billRemark = useSelector((state) => state.bill.remarkList);
  const [reasonOptions, setReasonOptions] = useState([]);
  const [billRemarkMap, setBillRemarkMap] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    dispatch(billHandler.getBillCancelRemark());
  }, [dispatch]);

  useEffect(() => {
    if (billRemark?.length > 1) {
      const options = billRemark.map((item) => item.name);
      const remarkMap = billRemark.reduce((acc, remark) => {
        acc[remark.name] = remark.id;
        return acc;
      }, {});

      setBillRemarkMap(remarkMap);
      setReasonOptions(options);
    }
  }, [billRemark]);

  const calculateTotalPrice = (item) => {
    const pricePerUnit = parseFloat(item.productPricePerPiece || 0);
    return (pricePerUnit * item.product_return_qty).toFixed(2);
  };

  const sum =
    product.length > 0
      ? product
          .filter((pd) => pd.product_return_qty > 0)
          .reduce((total, pd) => total + parseFloat(calculateTotalPrice(pd)), 0)
      : 0;

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);

      const productsToReturn = product.filter((p) => p.product_return_qty > 0);

      const productsWithPrices = productsToReturn.map((item) => ({
        ...item,
        calculatedPrice: calculateTotalPrice(item),
      }));

      setReturnProduct((prev) => ({
        ...prev,
        product: productsWithPrices,
      }));

      setStep(4);
    } catch (error) {
      console.error("Error preparing return products:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleReasonChange = (value) => {
    setReturnProduct((prev) => ({
      ...prev,
      reason: value,
      reason_id: billRemarkMap[value],
    }));
  };

  return (
    <>
      <div className="text-[20px] font-semibold mb-4">ยืนยันการคืนสินค้า</div>
      <ul className="p-0 m-0 w-100">
        <li className="px-2">
          <div className="row gx-2 align-items-start mb-3">
            <div className="col-6 fs-14">รายการ</div>
            <div className="col fs-14 text-center">จำนวน</div>
            <div className="col fs-14 text-end">ราคา</div>
          </div>
        </li>
        {product
          .filter((item) => item.product_return_qty > 0)
          .map((item) => (
            <li className="px-2" key={item.id}>
              <div className="row gx-2 align-items-start mb-3">
                <div className="col-6 mb-2">
                  <div className="d-flex align-items-center">
                    <img
                      src={item.productImage}
                      className="foodimg w-[52px] h-[39px] object-cover"
                      alt={item.productName}
                    />
                    <div className="fs-12 ms-2">{item.productName}</div>
                  </div>

                  <div className="d-flex flex-wrap bx-Foption">
                    {item.optionstandard?.map((option) => (
                      <div className="Foption mt-2" key={option.listID}>
                        {option.itemName}
                      </div>
                    ))}
                    {item.optionproduct?.map((option) => (
                      <div className="Foption mt-2" key={option.listID}>
                        {option.itemName}
                      </div>
                    ))}
                  </div>

                  {((item.optionnote && item.optionnote.length > 0) ||
                    item.note) && (
                    <div className="fNote">
                      {item.optionnote?.map((note, index) => (
                        <span key={note.listID}>
                          {note.itemName}
                          {index !== item.optionnote.length - 1 ? "," : ""}{" "}
                        </span>
                      ))}
                      {item.note}
                    </div>
                  )}
                </div>
                <div className="col fs-14 text-[#F95057] text-center foodQtyli mt-2">
                  {item.product_return_qty}
                </div>
                <div className="col fs-14 text-[#F95057] text-end mt-2">
                  <span className="foodPriceli">
                    {calculateTotalPrice(item)}
                  </span>
                  .-
                </div>
              </div>
            </li>
          ))}
      </ul>
      <div className="bg-[#CAE0FD] px-3 py-2 flex justify-between text-[#0760FC] rounded-lg">
        <div>ยอดรวมทั้งหมด</div>
        <div>{sum.toFixed(2)}฿</div>
      </div>
      <div className="row mt-3 mb-4">
        <div className="col-6">
          <div className="fs-14 mb-1">เหตุผล</div>
          <CustomSelect
            options={reasonOptions}
            label={reasonOptions[0]}
            selectedOptionObj={{
              selectedOption: returnProduct.reason,
              setSelectedOption: (e) => handleReasonChange(e.target.value),
            }}
            inputprops={{
              onChange: (e) => handleReasonChange(e.target.value),
              defaultValue: reasonOptions[0],
            }}
          />
        </div>
        <div className="col-6">
          <div className="fs-14 mb-1">หมายเหตุ</div>
          <CustomInput
            inputprops={{
              type: "text",
              className:
                "rounded-[min(0.78vw,8px)] h-[min(4.30vw,44px)] px-[min(1.27vw,13px)] py-[min(1.03vw,10.5px)] text-18 leading-[4] placeholder:h-full bg-[#FFF] border-[1px] border-[var(--color-grey-4)]",
              placeholder: "-",
              onChange: (e) => {
                setReturnProduct((prev) => ({
                  ...prev,
                  note: e.target.value,
                }));
              },
              value: returnProduct.note,
            }}
          />
        </div>
      </div>
      <div className="text-end py-2">
        <button
          type="button"
          className="btn btn-st-2 px-5 py-3 lh-1 me-3 bg-[#E6E6E6]"
          onClick={() => setStep(2)}
          disabled={isSubmitting}
        >
          ย้อนกลับ
        </button>
        <button
          className="btn btn-login px-5 py-3 lh-1"
          onClick={handleSubmit}
          disabled={isSubmitting || !returnProduct.reason}
        >
          {isSubmitting ? "กำลังดำเนินการ..." : "ถัดไป"}
        </button>
      </div>
    </>
  );
};
